import axios from "axios";
import { ToastType } from "../../ToastManager/constants";
import { sendNotification } from "../../ToastManager/ToastManager";

const initialState = {
  stepData: null,
};

const SET_CURRENT_TYPE = "SET_CURRENT_TYPE";
const RESET_STATE = "RESET_STATE";

const getStepData = (state) => state?.stepData;

export const nextStepsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_TYPE:
      const { stepData } = action;
      return {
        ...state,
        stepData: stepData,
      };
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
};

const fetchNextSteps = () => (dispatch) => {
  return axios
    .get("/api/survey/participant/nextstep")
    .then(({ data }) => {
      return dispatch({ type: SET_CURRENT_TYPE, stepData: data });
    })
    .catch((e) =>
      sendNotification("Error trying to fetch user lifecycle.", ToastType.ERROR)
    );
};

const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

export const mapDispatchToProps = { fetchNextSteps, resetState };
export const mapStateToProps = (state) => {
  return {
    stepData: getStepData(state),
  };
};
